/* eslint react/forbid-prop-types: 0 */
/* eslint react/no-did-mount-set-state: 0 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import BigCalendar from "react-big-calendar";
import moment from "moment";
import { connect } from "react-redux";
import { Row, Col, ButtonGroup, Button, Glyphicon } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import Loading from "../../Loading";
import Client from "../../../Client";
import RunsheetCalendarEvent from "./RunsheetCalendarEvent";
import CalendarFilters from "./CalendarFilters";
import CalendarDatePicker from "./CalendarDatePicker";
import CalendarFooter from "./CalendarFooter";
import updateFilters from "../../../actions/filters";
import updateDate from "../../../actions/date";
import {
  getCalendarRunsheets,
  cancelRunsheet
} from "../../../actions/runsheets";
import "./calendar_overrides.css";
import RunsheetUpload from "./RunsheetUpload";

BigCalendar.momentLocalizer(moment);

class RunsheetCalendar extends Component {
  state = {
    loading: true,
    date: moment(),
    jsDate: moment().toDate(),
    statuses: "ALL",
    error: false,
    display: "CALENDAR",
    filters: {
      statuses: "ALL",
      vehicleId: "",
      driverId: ""
    }
  };

  componentDidMount() {
    const { date, filters } = this.props;
    const momentDate = moment(date);
    const fromDate = this.getStartOfDateRange(momentDate);
    const toDate = this.getEndOfDateRange(momentDate);
    const options = { fromDate, toDate, ...filters };
    this.props
      .getCalendarRunsheets(options)
      .then(this.setState({ loading: false }));

    Client.getFleets();
  }

  getStartOfDateRange = momentDate =>
    momentDate
      .clone()
      .startOf(this.dateRange())
      .toISOString();

  getStartDate = event => moment(event.scheduledAt).toDate();

  getEndDate = event =>
    moment(event.scheduledAt)
      .add(2, "seconds")
      .toDate();

  getEndOfDateRange = momentDate =>
    momentDate
      .clone()
      .endOf(this.dateRange())
      .toISOString();

  dateRange = () => "week";
  dateFormat = () => "YYYY-MM-DD";

  handleFilterChange = filters => {
    this.setState({ loading: true });
    const { date } = this.state;
    this.props.updateFilters(filters);
    const fromDate = this.getStartOfDateRange(date);
    const toDate = this.getEndOfDateRange(date);
    const query = { fromDate, toDate, ...filters };
    this.props
      .getCalendarRunsheets(query)
      .then(this.setState({ loading: false }));
  };

  handleDateChange = date => {
    this.setState({ date, loading: true });
    this.props.updateDate(date.toISOString());
    const fromDate = this.getStartOfDateRange(date);
    const toDate = this.getEndOfDateRange(date);
    const query = { fromDate, toDate, ...this.state.filters };
    this.props
      .getCalendarRunsheets(query)
      .then(this.setState({ loading: false }));
  };

  // Kind of pointless, but needed to keep calendar happy
  handleChange = date => {
    this.setState({ jsDate: date });
  };

  calendarFormats = () => ({
    dayFormat: (date, culture, localizer) =>
      localizer.format(date, "ddd D", culture)
  });

  render() {
    if (this.state.error) {
      return <p>Unable to retrieve data</p>;
    }

    const { date, filters } = this.props;
    const { runsheets } = this.props;
    const momentDate = moment(date);

    return (
      <div>
        <div className="calendar-filters">
          <CalendarDatePicker
            date={momentDate}
            onChange={this.handleDateChange}
          />

          <CalendarFilters
            filters={filters}
            onChange={this.handleFilterChange}
          />

          <div className="runsheets-view-container">
            <ButtonGroup>
              <Button
                title="Table View"
                onClick={() => this.props.handleDisplayChange("TABLE")}
              >
                <Glyphicon glyph="th-list" />
              </Button>
              <Button bsStyle="primary" title="Calendar View">
                <Glyphicon glyph="calendar" />
              </Button>
            </ButtonGroup>{" "}
            <div className="knowledgebase-container">
              <a
                title="Task Manager Guide"
                href="https://transtech.atlassian.net/wiki/x/EgCZEg"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="sprite-image icon_knowledgebase" />
              </a>
            </div>
          </div>
          <div className="runsheet-calendar-actions display-inline">
            <Button href="/runsheets/new">
              <Glyphicon glyph="plus" /> Add New Runsheet
            </Button>{" "}
            <div className="display-inline">
              <RunsheetUpload />
            </div>
          </div>
        </div>

        {this.state.loading ? (
          <Loading />
        ) : (
          <Row>
            <Col xs={12}>
              <BigCalendar
                allDayAccessor={() => true}
                date={momentDate.toDate()}
                defaultView="week"
                events={runsheets}
                views={["week"]}
                startAccessor={this.getStartDate}
                endAccessor={this.getEndDate}
                onNavigate={d => this.handleChange(d)}
                step={60}
                timeslots={1}
                toolbar={false}
                components={{
                  event: RunsheetCalendarEvent
                }}
                eventPropGetter={() => ({ className: "created-event" })}
                formats={this.calendarFormats()}
              />
            </Col>
          </Row>
        )}

        <CalendarFooter />
      </div>
    );
  }
}
RunsheetCalendar.propTypes = {
  runsheets: PropTypes.array.isRequired,
  filters: PropTypes.object.isRequired,
  updateFilters: PropTypes.func.isRequired,
  date: PropTypes.string.isRequired,
  updateDate: PropTypes.func.isRequired,
  handleDisplayChange: PropTypes.func.isRequired,
  getCalendarRunsheets: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  runsheets: state.runsheets.calendar,
  filters: state.filters,
  date: state.date
});
const mapDispatchToProps = {
  updateFilters,
  updateDate,
  getCalendarRunsheets,
  cancelRunsheet
};

export default connect(mapStateToProps, mapDispatchToProps)(RunsheetCalendar);



// WEBPACK FOOTER //
// ./src/components/runsheets/list/RunsheetCalendar.js